"use strict";
var React = require("react");
var Button = require("react-bootstrap").Button;
var AuthStore     = require("../../stores/AuthenticationStore");
var AuthActions     = require("../../actions/AuthenticationActions");
var CompanyStore     = require("../../stores/CompanyStore");
var CompanyActions     = require("../../actions/CompanyActions");
var _ = require("underscore");
var clone = require("clone");
var moment = require('moment');
var EditProfileModal = require("./EditProfileModal");
var EditProfileForm = require("./EditProfileForm");


var Profile = React.createClass({
    getInitialState() {
        var newState = AuthStore.getState();

        var departments = CompanyStore.getState().departments;
        var sortedDepartments = _.indexBy(departments, "id");

        newState["departments"] = sortedDepartments;
        newState["profilePicture"] = "https://scontent-lhr3-1.xx.fbcdn.net/hphotos-xaf1/v/t1.0-9/11025642_10152777864332945_7317107260376286076_n.jpg?oh=f7b7941ab838585340e6b93071329032&oe=56EBA3D8"
        newState["showModal"] = false;

        return newState;
    },
    componentWillMount() {
        AuthActions.getUserInfo();
        CompanyActions.getDepartments();
    },
    componentDidMount() {
        AuthStore.listen(this.onChange);
    },
    componentWillUnmount() {
        AuthStore.unlisten(this.onChange);
    },
    onChange: function() {
        this.setState(this.getInitialState());
    },
    close(){
        this.setState({ showModal: false });
    },
    open(){
        this.setState({ showModal: true });
    },
    render: function() {
        var home_department = this.state.departments[this.state.home_department];
        var isActive = this.state.is_active === true ? "Virkur" : "Óvirkur";
        var isAdmin = this.state.is_superuser === true ? "Stjórnandi" : "Starfsmaður";
        return (
            <div className="content_section">
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 paper">
                            <div className="row profile-header">
                                <h3>{this.state.first_name+" "+this.state.last_name}</h3>
                                <EditProfileModal show={this.state.showModal} onHide={this.close} user={this.state}/>
                                <Button className="page-scroll btn btn-xl" onClick={this.open}>Breyta upplýsingum</Button>
                            </div>
                            <div className="row profile-body">
                                <div className="col-xs-6 profile-left">
                                    <ul className="profile-list">
                                        <li>
                                            <div className="title"><strong>{"Notandanafn: "}</strong></div>
                                            {this.state.username}
                                        </li>
                                        <li>
                                            <div className="title"><strong>{"Tölvupóstur: "}</strong></div>
                                            {this.state.email}
                                        </li>
                                        <li>
                                            <div className="title"><strong>{"Heimadeild: "}</strong></div>
                                            {home_department && home_department.name}
                                        </li>
                                        <li>
                                            <div className="title"><strong>{"Tegund: "}</strong></div>
                                            {isAdmin}
                                        </li>
                                        <li>
                                            <div className="title"><strong>{"Staða: "}</strong></div>
                                            {isActive}
                                        </li>
                                        <li>
                                            <div className="title"><strong>{"Bætt við: "}</strong></div>
                                            {moment(this.state.date_joined).format("YYYY-MM-DD")}
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-xs-6 profile-right">
                                    {this.state.profilePicture ?
                                        <img className="profilePicture" src={this.state.profilePicture} /> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
});

module.exports = Profile;



// WEBPACK FOOTER //
// ./app/scripts/ui/UserProfile/Profile.react.js